import { connect } from 'react-redux';
import { default as PaymentRoot } from './Payment';
import { getSearch } from 'src/store/Dashboard/actions';

const mapStateToProps = ({ dashboard, id }) => ({
  graph: dashboard.graph,
  id: id,
  user: dashboard.user,
});

export const Payment = connect(mapStateToProps, {
  getSearch,
})(PaymentRoot);
